import axios from "axios";
import {convertiTimestampInDataPerDb} from "../../../utility/common";

export const getCommentiKpiApi = (idKpi, idTipoImportDati) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/kpi/${idKpi}?id_tipo_imp_dati=${idTipoImportDati}`);
};

export const setUltimaLetturaCommentiKpiApi = (idKpi, idTipoImportDati) => {
    let ultimaLetturaCommenti = convertiTimestampInDataPerDb(new Date());
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/kpi/${idKpi}/ultima-lettura?id_tipo_imp_dati=${idTipoImportDati}&ultima_lettura_commenti=${ultimaLetturaCommenti}`);
};

export const eliminaCommentoApi = (idCommento) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/${idCommento}`);
};

export const getCommentoKpiByIdApi = (idCommento, idTipoImport) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/${idCommento}?id_tipo_imp_dati=${idTipoImport}`);
};

export const aggiornaCommentoKpiApi = (idCommento, commento) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/${idCommento}`, commento);
};

export const aggiungiCommentoKpiApi = (idKpi, commento) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/sost/commenti/kpi/${idKpi}`, commento);
};
